import { defineStore } from "pinia";
export const useLoginStore = defineStore("loginStore", {
  state: () => ({
    user: {},
    loggedIn: false,
    impersonating: false,
    adminEmail: null,
  }),
  getters: {
    getUser(state) {
      return state.user;
    },
    getLoggedIn(state) {
      return state.loggedIn;
    },
    isAdmin(state) {
      return state.user?.user_type === "Admin" || state.user?.user_type === "Super Admin";
    },
    isSuperAdmin(state) {
      return state.user?.user_type === "Super Admin";
    },
    isLead(state) {
      return state.user?.user_type === "Lead";
    },
    isEmploymentSpecialist(state) {
      return state.user?.user_type === "Employment Specialist";
    },
    isCaregiver(state) {
      return state.user?.user_type === "Caregiver" || state.user?.user_type === "Employment Specialist";
    },
    isImpersonating(state) {
      return state.impersonating;
    },
    getAdminEmail(state) {
      return state.adminEmail;
    },
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    setLoggedIn(loggedIn) {
      this.loggedIn = loggedIn;
    },
    setImpersonating(impersonating, adminEmail = null) {
      this.impersonating = impersonating;
      this.adminEmail = adminEmail;
    },
    clearImpersonation() {
      this.impersonating = false;
      this.adminEmail = null;
    },
  },
  persist: true,
});
